<ion-nav *ngIf="rootParams && rootComponent" [root]="rootComponent"
         [rootParams]="rootParams"></ion-nav>
